// extracted by mini-css-extract-plugin
module.exports = {"UserBadge":"UserBadge_UserBadge__2xXlF","nameBox":"UserBadge_nameBox__3ekf0","arrowClosed":"UserBadge_arrowClosed__2J4eI","arrowOpen":"UserBadge_arrowOpen__GECM3"};